import React, { Component } from "react";
import { withDomains, RESTExecutor } from "../../lib/domain";
import {
  Spin,
  Statistic,
  Table,
  Row,
  Tooltip,
  Icon,
  Divider,
  Col,
  Tag,
} from "antd";
import ErrorWrapper from "../../lib/error_wrapper";
import {
  formatMoney,
  showErrorInNotification,
  overrideHeaderBack,
} from "../../lib/util";
import { Link } from "react-router-dom";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import ReconciledYearBar from "../../components/reconciled_year_bar";
import { COLORS } from "../theme";
import { IconCard } from "../../components/basic_items";
import {
  Mood,
  SentimentSatisfied,
  SentimentDissatisfied,
} from "@material-ui/icons";
import {
  CountAmountStatsLarge,
  CountAmountStatsSmall,
  CustomStatsSmall,
} from "../../components/custom_stat";
import { BasicHeader } from "../../components/basic_header";
import moment from "moment";

const queryString = require("query-string");

const CountAndAmount = ({
  count = "N/A",
  amount = 0,
  query = {},
  reconciler_id,
  process_id,
}) => {
  return (
    <Statistic
      title={
        <Link
          to={{
            pathname: `/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${reconciler_id}/filteredtransactions`,
            search: queryString.stringify({
              // date:"2018-12-12"
              ...query,
            }),
          }}
        >
          <Text underline type="secondary">{`${count} Transactions`}</Text>
        </Link>
      }
      // title={`${count} Transactions`}
      value={formatMoney(amount, 2, ".", ",")}
    />
  );
};
const CountAndAmount1 = ({
  count = "N/A",
  amount = 0,
  query = {},
  reconciler_id,
  process_id,
}) => {
  return (
    <Statistic
      title={<Text type="secondary">{`${count} Transactions`}</Text>}
      // title={`${count} Transactions`}
      value={formatMoney(amount, 2, ".", ",")}
    />
  );
};

const unreconciled_by_process_table = (date_params) => [
  // {
  //     title: "Rules",
  //     dataIndex: 'name',
  //     key: 'name',
  //     render: (name, data) => <Link to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${data.reconciler_id}/process/${data.rule_id}`}>{name}</Link>

  // },
  // {
  //     title: "Ours",
  //     key: "ours_total",
  //     render: (data) => {
  //         return <CountAndAmount1
  //             reconciler_id={data.reconciler_id}
  //             process_id={data.rule_id}
  //             query={{ service_id: data.our_data_service_id }}
  //             count={
  //                 (data.our_count_month || 0) +
  //                 (data.our_count_quarter || 0) +
  //                 (data.our_count_lt_year || 0) +
  //                 (data.our_count_gt_year || 0)
  //             } amount={
  //                 (data.our_amount_month || 0) +
  //                 (data.our_amount_quarter || 0) +
  //                 (data.our_amount_lt_year || 0) +
  //                 (data.our_amount_gt_year || 0)
  //             } />
  //     }
  // }, {
  //     title: "Theirs",
  //     key: "theirs_total",
  //     render: (data) => {
  //         return <CountAndAmount1
  //             reconciler_id={data.reconciler_id}
  //             process_id={data.rule_id}
  //             query={{ service_id: data.their_data_service_id }}
  //             count={
  //                 (data.their_count_month || 0) +
  //                 (data.their_count_quarter || 0) +
  //                 (data.their_count_lt_year || 0) +
  //                 (data.their_count_gt_year || 0)
  //             } amount={
  //                 (data.their_amount_month || 0) +
  //                 (data.their_amount_quarter || 0) +
  //                 (data.their_amount_lt_year || 0) +
  //                 (data.their_amount_gt_year || 0)
  //             } />
  //     }
  // },
  {
    title: "Month",
    children: [
      {
        title: "Our",
        key: "our_month",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              count={data.our_count_month}
              amount={data.our_amount_month}
              query={{
                ...date_params.month,
                service_id: data.our_data_service_id,
              }}
            />
          );
        },
      },
      {
        title: "Their",
        key: "their_month",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              count={data.their_count_month}
              amount={data.their_amount_month}
              query={{
                ...date_params.month,
                service_id: data.their_data_service_id,
              }}
            />
          );
        },
      },
    ],
  },
  {
    title: "Quarter",
    children: [
      {
        title: "Our",
        key: "our_quarter",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              count={data.our_count_quarter}
              amount={data.our_amount_quarter}
              query={{
                ...date_params.quarter,
                service_id: data.our_data_service_id,
              }}
            />
          );
        },
      },
      {
        title: "Their",
        key: "their_quarter",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              count={data.their_count_quarter}
              amount={data.their_amount_quarter}
              query={{
                ...date_params.quarter,
                service_id: data.their_data_service_id,
              }}
            />
          );
        },
      },
    ],
  },
  {
    title: "<Year",
    children: [
      {
        title: "Our",
        key: "our_year_lt",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              count={data.our_count_lt_year}
              amount={data.our_amount_lt_year}
              query={{
                ...date_params.lt_year,
                service_id: data.our_data_service_id,
              }}
            />
          );
        },
      },
      {
        title: "Their",
        key: "their_year_lt",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              count={data.their_count_lt_year}
              amount={data.their_amount_lt_year}
              query={{
                ...date_params.lt_year,
                service_id: data.their_data_service_id,
              }}
            />
          );
        },
      },
    ],
  },
  {
    title: ">Year",
    children: [
      {
        title: "Our",
        key: "our_year_gt",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              query={{
                ...date_params.gt_year,
                service_id: data.our_data_service_id,
              }}
              count={data.our_count_gt_year}
              amount={data.our_amount_gt_year}
            />
          );
        },
      },
      {
        title: "Their",
        key: "their_year_gt",
        render: (data) => {
          return (
            <CountAndAmount
              reconciler_id={data.reconciler_id}
              process_id={data.rule_id}
              query={{
                ...date_params.gt_year,
                service_id: data.their_data_service_id,
              }}
              count={data.their_count_gt_year}
              amount={data.their_amount_gt_year}
            />
          );
        },
      },
    ],
  },
];
class ReconcilerGroupDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      source_obj: {},
    };
    this.reconciler_id = props.match.params.reconciler_id;
    this.source_id = props.match.params.source_id;
    this.group_id = props.match.params.group_id;

    this.detail_source = RESTExecutor.detail()
      .forId(this.source_id)
      .config({
        label: "groupsourcedetailbasics",
      })
      .callbacks(
        (success) => {
          // make first id default tab if not done previously
          this.setState({ source_obj: success.result });
        },
        (error) => { }
      )
      .connect(props.domains.usergroups);

    this.list_recon_dash = RESTExecutor.list()
      .config({
        label: "group_overview",
        params: {
          source_id: this.source_id,
        },
      })
      .callbacks(
        (success) => {
          this.setState({ loading: false });
          this.detail_source.forId(this.source_id).execute();
        },
        (error) => {
          this.setState({ loading: false });
          showErrorInNotification(error);
        }
      )
      .connect(props.domains.reconciliation);
  }

  render() {
    if (this.state.loading) {
      return (
        <div
          style={
            {
              // minHeight: '100vh'
            }
          }
        >
          <center>
            <Spin />
          </center>
        </div>
      );
    }
    const { source_obj } = this.state;
    let list_recon_dash_resp = this.list_recon_dash.response();
    let dash = list_recon_dash_resp.result || {};
    let aging = dash.unreconciled_aging || {};

    // let aging = unreconciled_aging_list[0] || {};

    let date_params = dash.date || {};

    let today_status = dash.reconciled_today || {};
    let week_status = dash.reconciled_week || {};
    let month_status = dash.month_stats || {};
    let reconciled = dash.reconciled || {};
    let pending = dash.pending;
    let manual_pending = dash.manual_pending || {};

    let total_pending = pending;
    // pending.map((item) => {
    //     total_pending += item.count
    // });
    // total_pending += manual_pending.count;

    let unreconciled_items = dash.unreconciled;
    let unreconciled = {
      our_count:
        (aging.our_count_month || 0) +
        (aging.our_count_quarter || 0) +
        (aging.our_count_lt_year || 0) +
        (aging.our_count_gt_year || 0),
      our_amount:
        (aging.our_amount_month || 0) +
        (aging.our_amount_quarter || 0) +
        (aging.our_amount_lt_year || 0) +
        (aging.our_amount_gt_year || 0),
      their_count:
        (aging.their_count_month || 0) +
        (aging.their_count_quarter || 0) +
        (aging.their_count_lt_year || 0) +
        (aging.their_count_gt_year || 0),
      their_amount:
        (aging.their_amount_month || 0) +
        (aging.their_amount_quarter || 0) +
        (aging.their_amount_lt_year || 0) +
        (aging.their_amount_gt_year || 0),
    };
    let reconciler = dash.reconciler || {};
    let reconciler_ref = reconciler.__references__ || {};
    let exclusions = reconciler_ref.exclusions || [];

    let our_data_type = reconciler_ref.our_data_type_id || {};
    let their_data_type = reconciler_ref.their_data_type_id || {};

    return (
      <ErrorWrapper
        error={list_recon_dash_resp}
        onReload={() => {
          this.setState({
            loading: true,
          });
          this.list_recon_dash.execute();
        }}
      >
        <div>
          <BasicHeader
            title={`${reconciler.name} Overview`}
            titleType="Processor"
            subtitle={source_obj.group_name}
            subtitleType={"Group"}
            subtitle2={source_obj.source_name}
            subtitleType2={"Source"}
          />
          <Row
            type="flex"
            style={{
              flexWrap: "wrap",
            }}
          >
            <Col
              {...{ xs: 24, sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }}
              style={{ padding: 8 }}
            >
              <IconCard
                type="success"
                icon={<Mood />}
                title={
                  week_status.txncount > 10000
                    ? "10,000+"
                    : formatMoney(week_status.txncount, 0)
                }
                subtitle="Processed Items (Last 7 days)"
                link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/reconciled`}
                style={{
                  height: "100%",
                }}
              />
            </Col>
            <Col
              {...{ xs: 24, sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }}
              style={{ padding: 8 }}
            >
              <IconCard
                type="warning"
                icon={<SentimentSatisfied />}
                title={
                  total_pending > 10000
                    ? "10,000+"
                    : formatMoney(total_pending, 0)
                }
                subtitle="Pending Items"
                link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending`}
                style={{
                  height: "100%",
                }}
              />
            </Col>
            <Col
              {...{ xs: 24, sm: 24, md: 12, lg: 8, xl: 8, xxl: 8 }}
              style={{ padding: 8 }}
            >
              <IconCard
                type="danger"
                icon={<SentimentDissatisfied />}
                title={formatMoney(unreconciled_items, 0)}
                subtitle="Unprocessed Items"
                link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/unreconciled`}
                style={{
                  height: "100%",
                }}
              />
            </Col>

            {/* <div
                            className='default-card'
                            style={{
                                padding: 16,
                                minWidth: 400,
                                flex: 1
                            }}>
                            <Title level={3} type='secondary'>Today</Title>
                            <Divider />
                            <Row type='flex'>
                                <Statistic
                                    title="Amount"
                                    value={today_status.total_amount}
                                    style={{
                                        marginRight: 40
                                    }} />
                                <Statistic title="Transactions" value={today_status.txncount} />
                            </Row>
                        </div>
                        <div
                            className='default-card'
                            style={{
                                padding: 16,
                                minWidth: 400,
                                flex: 1
                            }}>
                            <Title level={3} type='secondary'>This Week</Title>
                            <Divider />
                            <Row type='flex'>
                                <Statistic
                                    title="Amount"
                                    value={week_status.total_amount}
                                    style={{
                                        marginRight: 40
                                    }} />
                                <Statistic title="Transactions" value={week_status.txncount} />
                            </Row>
                        </div>
                        <div
                            className='default-card'
                            style={{
                                padding: 16,
                                minWidth: 400,
                                flex: 1
                            }}>
                            <Title level={3} type='secondary'>This Month</Title>
                            <Divider />
                            <Row type='flex'>
                                <Statistic
                                    title="Amount"
                                    value={month_status.total_amount}
                                    style={{
                                        marginRight: 40
                                    }} />
                                <Statistic title="Transactions" value={month_status.txncount} />
                            </Row>
                        </div>
                    */}
          </Row>

          {/* <Divider /> */}
          <Row
            type="flex"
            style={{
              flexWrap: "wrap",
            }}
          >
            {/* <Col {...{ xs: 24, sm: 24, md: 24, lg: 12, xl: 12, xxl: 12 }} style={{ padding: 8 }}>
                            <div className='default-card' style={{
                                margin: 0,
                                padding: 20, height: '100%'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'baseline'
                                }}>
                                    <span className='sub-heading-1' style={{
                                        color: COLORS.secondary
                                    }}>Pending Approval</span>

                                    <Link to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending`} className='sub-heading-2' style={{
                                        color: COLORS.warning_primary
                                    }}>VIEW ALL</Link>

                                </div>
                                <div style={{
                                    paddingTop: 30
                                }}>
                                    <Table
                                        className='small-table no-separator-table no-border-table '
                                        rowClassName={() => 'hand-cursor'}
                                        onRow={(record, index) => {
                                            return {
                                                onClick: () => {
                                                    this.props.history.push(`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending?rule_id=${record.rule_id}`)
                                                }
                                            };
                                        }}
                                        columns={[
                                            { title: "RECONCILIATION RULE", dataIndex: 'name', key: 'name' },
                                            {
                                                title: "TRANSACTIONS", dataIndex: 'count', key: 'count', width: 93,
                                                render: (count) => <div style={{
                                                    textAlign: 'right'
                                                }}>{count > 10000 ? "10,000+" : formatMoney(count, 0)
                                                    }</div>
                                            },
                                        ]}
                                        dataSource={pending}
                                        pagination={false}
                                        size='small'
                                    />
                                </div>
                            </div>
                        </Col>
                       */}
            <Col
              {...{ xs: 24, sm: 24, md: 24, lg: 12, xl: 12, xxl: 12 }}
              style={{ padding: 8 }}
            >
              <div
                className="default-card"
                style={{
                  margin: 0,
                  padding: 20,
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                >
                  <span
                    className="sub-heading-1"
                    style={{
                      color: COLORS.secondary,
                    }}
                  >
                    Unprocessed Items
                  </span>

                  <Link
                    to={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/unreconciled`}
                    className="sub-heading-2"
                    style={{
                      color: COLORS.danger_primary,
                    }}
                  >
                    VIEW ALL
                  </Link>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingTop: 40,
                  }}
                >
                  <CountAmountStatsLarge
                    label="OURS"
                    count={formatMoney(unreconciled.our_count, 0)}
                    amount={unreconciled.our_amount}
                  />
                  <CountAmountStatsLarge
                    containerStyle={{
                      alignItems: "flex-end",
                    }}
                    label="THEIRS"
                    count={formatMoney(unreconciled.their_count, 0)}
                    amount={unreconciled.their_amount}
                  />
                </div>
              </div>
            </Col>
            <Col
              {...{ xs: 24, sm: 24, md: 24, lg: 12, xl: 12, xxl: 12 }}
              style={{ padding: 8 }}
            >
              <div
                className="default-card"
                style={{
                  margin: 0,
                  padding: 20,
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                >
                  <span
                    className="sub-heading-1"
                    style={{
                      color: COLORS.secondary,
                    }}
                  >
                    Processor Info
                  </span>

                  {/* <Link to={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/pending`} className='sub-heading-2' style={{
                                        color: COLORS.warning_primary
                                    }}>VIEW ALL</Link> */}
                </div>
                <div
                  style={{
                    paddingTop: 30,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <CustomStatsSmall
                    label="OURS"
                    title={our_data_type.name}
                    labelStyle={{
                      color: "#000000",
                    }}
                  />
                  <CustomStatsSmall
                    label="THEIRS"
                    style={{
                      alignItems: "flex-end",
                    }}
                    labelStyle={{
                      color: "#000000",
                    }}
                    title={their_data_type.name}
                  />
                </div>
                <div
                  style={{
                    paddingTop: 20,
                  }}
                >
                  <CustomStatsSmall
                    label="EXCLUSIONS"
                    labelStyle={{
                      color: "#000000",
                    }}
                    content={
                      <div>
                        {exclusions.length === 0 ? (
                          <span style={{ opacity: 0.5 }}>
                            No any exclusions
                          </span>
                        ) : (
                          exclusions.map((item) => {
                            let ref = item.__references__ || {};
                            let recon = ref.excluded_group_id || {};
                            return (
                              <Link
                                to={{
                                  pathname: `/processors/groups/${this.group_id}/sources/${this.source_id}`,
                                  search: `tab=${item.excluded_group_id}`,
                                }}
                              >
                                <Tag
                                  className="hand-cursor"
                                  title={recon.name}
                                  style={{ margin: 4, marginLeft: 0 }}
                                >
                                  {recon.name}
                                </Tag>
                              </Link>
                            );
                          })
                        )}
                      </div>
                    }
                  />
                </div>
              </div>
            </Col>

            <Col
              {...{ xs: 24, sm: 24, md: 24, lg: 12, xl: 12, xxl: 12 }}
              style={{ padding: 8, display: "none" }}
            >
              <div
                className="default-card"
                style={{
                  margin: 0,
                  padding: 20,
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                >
                  <span
                    className="sub-heading-1"
                    style={{
                      color: COLORS.secondary,
                    }}
                  >
                    Processed Today
                  </span>

                  <Link
                    to={{
                      pathname: `/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/reconciled`,
                      search: queryString.stringify({
                        dateFrom: moment().format("YYYY-MM-DD"),
                        dateTo: moment().format("YYYY-MM-DD"),
                      }),
                    }}
                    className="sub-heading-2"
                    style={{
                      color: COLORS.success_primary,
                    }}
                  >
                    VIEW ALL
                  </Link>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    paddingTop: 40,
                  }}
                >
                  <CountAmountStatsLarge
                    label="OURS"
                    count={formatMoney(today_status.count, 0)}
                    amount={today_status.our_amount}
                  />
                  <CountAmountStatsLarge
                    containerStyle={{
                      alignItems: "flex-end",
                    }}
                    label="THEIRS"
                    count={formatMoney(today_status.count, 0)}
                    amount={today_status.their_amount}
                  />
                </div>
              </div>
            </Col>

            <Col
              {...{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 }}
              style={{ padding: 8 }}
            >
              <div
                className="default-card"
                style={{
                  margin: 0,
                  padding: 20,
                  height: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "baseline",
                  }}
                >
                  <span
                    className="sub-heading-1"
                    style={{
                      color: COLORS.secondary,
                    }}
                  >
                    Aging
                  </span>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingTop: 20,
                    }}
                  >
                    <span
                      className="heading-4"
                      style={{
                        color: COLORS.primary,
                      }}
                    >
                      LESS THAN A MONTH
                    </span>
                    <CountAmountStatsSmall
                      label="OUR"
                      count={formatMoney(aging.our_count_month, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.month,
                        data_type_id: reconciler.our_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.our_amount_month}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                    <CountAmountStatsSmall
                      label="THEIR"
                      count={formatMoney(aging.their_count_month, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.month,
                        data_type_id: reconciler.their_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.their_amount_month}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingTop: 20,
                    }}
                  >
                    <span
                      className="heading-4"
                      style={{
                        color: COLORS.primary,
                      }}
                    >
                      LESS THAN A QUARTER
                    </span>
                    <CountAmountStatsSmall
                      label="OUR"
                      count={formatMoney(aging.our_count_quarter, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.quarter,
                        data_type_id: reconciler.our_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.our_amount_quarter}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                    <CountAmountStatsSmall
                      label="THEIR"
                      count={formatMoney(aging.their_count_quarter, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.quarter,
                        data_type_id: reconciler.their_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.their_amount_quarter}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingTop: 20,
                    }}
                  >
                    <span
                      className="heading-4"
                      style={{
                        color: COLORS.primary,
                      }}
                    >
                      LESS THAN A YEAR
                    </span>
                    <CountAmountStatsSmall
                      label="OUR"
                      count={formatMoney(aging.our_count_lt_year, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.lt_year,
                        data_type_id: reconciler.our_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.our_amount_lt_year}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                    <CountAmountStatsSmall
                      label="THEIR"
                      count={formatMoney(aging.their_count_lt_year, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.lt_year,
                        data_type_id: reconciler.their_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.their_amount_lt_year}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingTop: 20,
                    }}
                  >
                    <span
                      className="heading-4"
                      style={{
                        color: COLORS.danger_primary,
                      }}
                    >
                      MORE THAN A YEAR
                    </span>
                    <CountAmountStatsSmall
                      label="OUR"
                      count={formatMoney(aging.our_count_gt_year, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.gt_year,
                        data_type_id: reconciler.our_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.our_amount_gt_year}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                    <CountAmountStatsSmall
                      label="THEIR"
                      count={formatMoney(aging.their_count_gt_year, 0)}
                      count_link={`/processors/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                      count_link_params={{
                        ...date_params.gt_year,
                        data_type_id: reconciler.their_data_type_id,
                        source_id: this.source_id,
                      }}
                      amount={aging.their_amount_gt_year}
                      containerStyle={{
                        marginTop: 20,
                      }}
                    />
                  </div>
                </div>
              </div>
            </Col>

            {/* <Col {...{ xs: 24, sm: 24, md: 24, lg: 24, xl: 24, xxl: 24 }} style={{ padding: 8 }}>
                        <div className='default-card' style={{
                                margin: 0,
                                padding: 20,
                                height:'100%'
                            }}>
                                  <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'baseline'
                                }}>
                                    <span className='sub-heading-1' style={{
                                        color: COLORS.secondary
                                    }}>Aging</span>

                                </div>

                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap:'wrap',
                                }}>
                                    <div style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        paddingTop:20
                                    }}>
                                        <span className='heading-4' style={{
                                            color:COLORS.primary,
                                        }}>LESS THAN A MONTH</span>
                                        <CountAmountStatsSmall 
                                        label="OUR"
                                        count={formatMoney(aging.our_count_month,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.month,datatype:aging.our_data_type_id}}


                                        amount={aging.our_amount_month}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                        <CountAmountStatsSmall 
                                        label="THEIR"
                                        count={formatMoney(aging.their_count_month,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.month,datatype:aging.their_data_type_id}}
                                        amount={aging.their_amount_month}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                    </div>
                                    <div style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        paddingTop:20
                                    }}>
                                        <span className='heading-4' style={{
                                            color:COLORS.primary,
                                        }}>LESS THAN A QUARTER</span>
                                        <CountAmountStatsSmall 
                                        label="OUR"
                                        count={formatMoney(aging.our_count_quarter,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.quarter,datatype:aging.our_data_type_id}}
                                        amount={aging.our_amount_quarter}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                        <CountAmountStatsSmall 
                                        label="THEIR"
                                        count={formatMoney(aging.their_count_quarter,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.quarter,datatype:aging.their_data_type_id}}
                                        amount={aging.their_amount_quarter}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                    </div>
                                    <div style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        paddingTop:20
                                    }}>
                                        <span className='heading-4' style={{
                                            color:COLORS.primary,
                                        }}>LESS THAN A YEAR</span>
                                        <CountAmountStatsSmall 
                                        label="OUR"
                                        count={formatMoney(aging.our_count_lt_year,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.lt_year,datatype:aging.our_data_type_id}}
                                        amount={aging.our_amount_lt_year}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                        <CountAmountStatsSmall 
                                        label="THEIR"
                                        count={formatMoney(aging.their_count_lt_year,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.lt_year,datatype:aging.their_data_type_id}}
                                        amount={aging.their_amount_lt_year}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                    </div>
                                    <div style={{
                                        display:'flex',
                                        flexDirection:'column',
                                        paddingTop:20
                                    }}>
                                        <span className='heading-4' style={{
                                            color:COLORS.danger_primary,
                                        }}>MORE THAN A YEAR</span>
                                        <CountAmountStatsSmall 
                                        label="OUR"
                                        count={formatMoney(aging.our_count_gt_year,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.gt_year,datatype:aging.our_data_type_id}}
                                        amount={aging.our_amount_gt_year}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                        <CountAmountStatsSmall 
                                        label="THEIR"
                                        count={formatMoney(aging.their_count_gt_year,0)}
                                        count_link={`/recon/groups/${this.group_id}/sources/${this.source_id}/reconcilers/${this.reconciler_id}/filteredtransactions`}
                                        count_link_params={{...date_params.gt_year,datatype:aging.their_data_type_id}}
                                        amount={aging.their_amount_gt_year}
                                        containerStyle={{
                                            marginTop:20
                                        }}
                                        />
                                    </div>
                                </div>

                        </div></Col>
                     */}
          </Row>

          {/* <div className='default-card' style={{
                        padding: 8
                    }}>

                        <ReconciledYearBar data={dash.year || []} />
                    </div> */}
        </div>
      </ErrorWrapper>
    );
  }

  componentDidMount() {
    this.list_recon_dash
      .forId(this.reconciler_id)
      .config({
        params: {
          source_id: this.source_id,
        },
      })
      .execute();
  }

  componentWillUnmount() {
    overrideHeaderBack(null);
  }

  componentDidUpdate = (prevProps) => {
    if (
      this.props.match.params.reconciler_id !==
      prevProps.match.params.reconciler_id ||
      this.props.match.params.source_id !== prevProps.match.params.source_id
    ) {
      this.reconciler_id = this.props.match.params.reconciler_id;
      this.source_id = this.props.match.params.source_id;
      this.setState({
        loading: true,
      });
      this.list_recon_dash
        .forId(this.reconciler_id)
        .config({
          params: {
            source_id: this.source_id,
          },
        })
        .execute();
      // fetch the new product based and set it to the state of the component
    }
  };
}

export default withDomains(
  ReconcilerGroupDetail,
  "reconciliation",
  "usergroups"
);
